
teamoesterreich.core.start();